import { gql } from '@apollo/client';


export const VEHICLE_MAKE_AUTO_SUGGEST = gql`
  query vehicleMakeAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    vehicleMakeAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;

export const VEHICLE_MODEL_AUTO_SUGGEST = gql`
  query vehicleModelAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    vehicleModelAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;

export const VEHICLE_VIN_AUTO_SUGGEST = gql`
  query vehicleVinAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    vehicleVinAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;

export const VEHICLE_PLATE_AUTO_SUGGEST = gql`
  query vehiclePlateAutoSuggest($input: String!, $count: Int!, $originatorId: ID!){
    vehiclePlateAutoSuggest(input: $input, count: $count, originatorId: $originatorId) {
      id
      match
      value
    }
  }
`;

